import { io } from 'socket.io-client'
import webKeys from '../config/keys'

const keys = (webKeys) as {
  baseUrl: string
}

export const CONNECTION_PORT = keys.baseUrl
// let CONNECTION_PORT = "https://preprod-shielded-dawn-73021.herokuapp.com";

// Use both polling and websocket transports so the client can fall back to polling
// if the WebSocket upgrade is prevented by a proxy/server. Keep autoConnect false
// so we connect explicitly once from the app bootstrap.
const socket = io(CONNECTION_PORT, {
  transports: ['websocket'], // Force WebSocket transport only (no polling)
  upgrade: false, // Disable protocol upgrade attempts
  reconnection: true, // Enable auto-reconnection
  reconnectionDelay: 1000, // Wait 1s before reconnecting
  reconnectionAttempts: 5 // Try 5 times before giving up
})

// Debug / diagnostic handlers to surface connection errors in the browser console.
// These will help identify handshake failures (CORS, proxy blocking, auth issues).
socket.on('connect', () => {
  // eslint-disable-next-line no-console
  console.info('[socket] connected', socket.id)
})

socket.on('connect_error', (err: any) => {
  // eslint-disable-next-line no-console
  console.error('[socket] connect_error', err)
})

socket.on('reconnect_attempt', (attempt: number) => {
  // eslint-disable-next-line no-console
  console.info('[socket] reconnect_attempt', attempt)
})

export const sendReloadInfo = (orderId: any, pharmacyId: any): void => {
  const content = {
    content: {
      orderId: orderId,
      pharmacyId: pharmacyId
    },
    room: 'superadmin'
  }
  socket.emit('send_reload_info', content)
}

export const sendReloadSuperAdmin = (): void => {
  socket.emit('reload_orders', 'superadmin')
}

export const reloadTntFile = (cb: any, orderId: number): (() => void) => {
  const handler = (data: any) => {
    if (data.content.orderId === orderId) {
      cb().catch((err: any) => console.log(err))
    }
  }

  socket.on('reload_tnt_file', handler)

  // Return an unsubscribe function so callers can cleanup listener
  return () => { socket.off('reload_tnt_file', handler) }
}

export default socket
